module.exports = __webpack_public_path__ + "static/img/social-mobility-in-graduate-recruitment.07bf6ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/research/social-mobility-in-graduate-recruitment.png
// module id = 60aL
// module chunks = 0